// extracted by mini-css-extract-plugin
export default {"scrollableMenu":"NewIamRole_scrollableMenu__9p4pZ","roleTypeValue":"NewIamRole_roleTypeValue__e1LFo","tooltip":"NewIamRole_tooltip__26Dl8"};